import { DynamoDB, AWSError } from 'aws-sdk';
import { Auth } from 'aws-amplify';

import { QuestionsItemType, ICredentials, IDynamoDbGetParams } from './interfaces';

import { DYNAMO_DB_TABLES } from '@modules/core/constants';

export async function getQuestions(): Promise<QuestionsItemType> {
  const credentials: ICredentials = await Auth.currentCredentials();

  const client: DynamoDB.DocumentClient = new DynamoDB.DocumentClient({
    region: process.env.REACT_APP_AWS_REGION || 'us-east-1',
    credentials: Auth.essentialCredentials(credentials),
  });

  const params: IDynamoDbGetParams = {
    TableName: DYNAMO_DB_TABLES.objectTemplates,
    Key: {
      TemplateName: 'myCircle Onboarding',
      HierarchyCatagory: 'Profile',
    },
  };

  return new Promise<QuestionsItemType>((resolve, reject): void => {
    client.get(params, (err: AWSError, data: DynamoDB.DocumentClient.GetItemOutput): void => {
      if (err) {
        return reject(new Error(err.message || JSON.stringify(err)));
      }

      if (!data?.Item?.Fields) {
        return reject(new Error('No data was found'));
      }

      return resolve(data.Item as QuestionsItemType);
    });
  });
}
